import { FC } from 'react'
import { RecoilRoot } from 'recoil'
import 'sanitize.css'
import './fonts/KiwiMaru-Regular.ttf'
import { AppRoute } from './routes'
import './styles/globals.scss'
import './styles/mi.scss'

export const App: FC = () => {
  return (
    <RecoilRoot>
      <AppRoute />
    </RecoilRoot>
  )
}
